class FacetFiltersForm extends HTMLElement {
  static desktopMediaQuery = window.matchMedia('(min-width: 990px)');

  static isDesktopFacets() {
    return FacetFiltersForm.desktopMediaQuery.matches;
  }

  static closeDesktopDrawer(collectionWrapper) {
    if (!collectionWrapper) return;
    const facetWrapper = collectionWrapper.querySelector('.facets__wrapper');
    const overlay = collectionWrapper.querySelector('.products-grid__overlay');
    if (facetWrapper) facetWrapper.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleDesktopDrawerMediaChange = this.handleDesktopDrawerMediaChange.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));
    }

    if (this.classList.contains('mobile-facets__sort-inline')) {
      FacetFiltersForm.bindMobileSortDisplay(this);
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    const collectionWrapper = this.closest('.collection-wrapper');

    const facetButtons = this.querySelectorAll(".facets__open-button");
    facetButtons.forEach((facetButton) => {
      facetButton.onclick = () => {
        if (FacetFiltersForm.isDesktopFacets()) {
          document.querySelector('#FacetsWrapperDesktop')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        this.querySelector(".facets__wrapper").classList.add("active");
        collectionWrapper
          .querySelector(".products-grid__overlay")
          .classList.add("active");
        document.body.classList.add("overflow-hidden");
      };
    });

    const overlay = collectionWrapper?.querySelector(".products-grid__overlay");
    if (overlay) {
      overlay.onclick = (event) => {
        if (FacetFiltersForm.isDesktopFacets()) return;
        FacetFiltersForm.closeDesktopDrawer(event.currentTarget.closest(".collection-wrapper"));
      }
    }

    const facetsClose = this.querySelector(".facets__close");
    if (facetsClose) {
      facetsClose.onclick = () => {
        if (FacetFiltersForm.isDesktopFacets()) return;
        FacetFiltersForm.closeDesktopDrawer(collectionWrapper);
      };
    }

    const applyButton = this.querySelector('.facets__wrapper-bottom .button--results');
    if (applyButton) {
      applyButton.addEventListener('click', () => {
        if (FacetFiltersForm.isDesktopFacets()) return;
        const facetsCloseButton = this.querySelector('.facets__close');
        if (facetsCloseButton) facetsCloseButton.click();
      });
    }

    FacetFiltersForm.desktopMediaQuery.addEventListener('change', this.handleDesktopDrawerMediaChange);
    this.handleDesktopDrawerMediaChange();
  }

  disconnectedCallback() {
    FacetFiltersForm.desktopMediaQuery.removeEventListener('change', this.handleDesktopDrawerMediaChange);
  }

  handleDesktopDrawerMediaChange() {
    if (FacetFiltersForm.isDesktopFacets()) {
      FacetFiltersForm.closeDesktopDrawer(this.closest('.collection-wrapper'));
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    
    if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) {
      loadMore();
    }

    colorSwatches();
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const count = parsedHTML.getElementById('ProductCount')?.innerHTML || '0 results';
    const countSimple = parsedHTML.getElementById('ProductCountDesktop')?.innerHTML
      || parsedHTML.getElementById('ProductCountMobile')?.innerHTML
      || count;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobileDrawer = document.querySelector('.mobile-facets__count');
    const containerMobile = document.getElementById('ProductCountMobile');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = countSimple;
      containerDesktop.classList.remove('loading');
    }
    if (containerMobileDrawer) {
      containerMobileDrawer.innerHTML = count;
    }
    if (containerMobile) {
      containerMobile.innerHTML = countSimple;
      containerMobile.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop', '.active-facets-mobile-panel'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const targetElement = document.querySelector(selector);
      targetElement.innerHTML = activeFacetsElement.innerHTML;

      if (selector === '.active-facets-desktop' || selector === '.active-facets-mobile-panel') {
        targetElement.classList.toggle(
          'active-facets-sidebar--empty',
          !activeFacetsElement.querySelector('.facets__filtered-by-title')
        );
      }

      if (activeFacetsElement.querySelector('.active-facets__button')) {
        document.querySelectorAll(".facets__open-button").forEach((button) => {
          button.classList.add('facets__open-button_accent');
        });
      }
      else {
        document.querySelectorAll(".facets__open-button").forEach((button) => {
          button.classList.remove('facets__open-button_accent');
        });
      }

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__wrapper-bottom .button--secondary")) {
        document.querySelector(".facets__wrapper-bottom .button--secondary").removeAttribute('disabled');
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".facets__wrapper-bottom .button--secondary")) {
        document.querySelector(".facets__wrapper-bottom .button--secondary").setAttribute('disabled', '');
      }

      if (activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".mobile-facets__clear")) {
        document.querySelectorAll(".mobile-facets__clear").forEach(item => {
          item.removeAttribute('disabled');
        })
      }
      else if (!activeFacetsElement.querySelector('.active-facets__button') && document.querySelector(".mobile-facets__clear")) {
        document.querySelectorAll(".mobile-facets__clear").forEach(item => {
          item.setAttribute('disabled', '');
        })
      }

    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileMenuDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (mobileMenuDrawer) {
      mobileMenuDrawer.bindEvents();
      FacetFiltersForm.bindMobileFacetAccordions(mobileMenuDrawer);
    }
  }

  static bindMobileSortDisplay(root = document) {
    root.querySelectorAll('.mobile-facets__sort-pill').forEach((pill) => {
      const select = pill.querySelector('.mobile-facets__sort-select');
      const display = pill.querySelector('[data-sort-display]');
      if (!select || !display) return;

      const updateDisplay = () => {
        const selectedOption = select.options[select.selectedIndex];
        display.textContent = selectedOption ? selectedOption.text.trim() : '';
      };

      if (!select.dataset.sortDisplayBound) {
        select.dataset.sortDisplayBound = 'true';
        select.addEventListener('change', updateDisplay);
      }

      updateDisplay();
    });
  }

  static bindMobileFacetAccordions(menuDrawer = document.querySelector('.mobile-facets__wrapper')) {
    if (!menuDrawer) return;

    const headerClose = menuDrawer.querySelector('.mobile-facets__header-icon');
    if (headerClose && !headerClose.dataset.accordionBound) {
      headerClose.dataset.accordionBound = 'true';
      headerClose.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        const mainDetails = menuDrawer.querySelector(':scope > details');
        if (mainDetails?.hasAttribute('open')) {
          menuDrawer.querySelector(':scope > details > summary')?.click();
        }
      }, true);
    }

    menuDrawer.querySelectorAll('.mobile-facets__details > summary').forEach((summary) => {
      if (summary.dataset.accordionBound) return;
      summary.dataset.accordionBound = 'true';
      summary.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
      }, true);
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === 'FacetSortForm' ||
            form.id === 'FacetFiltersForm' ||
            form.id === 'FacetSortDrawerForm' ||
            form.classList.contains('mobile-facets__sort-form')
          ) {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.bindMobileFacetAccordions();
FacetFiltersForm.bindMobileSortDisplay();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
    this.fillSlider();
    this.updatePriceDisplay();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    this.fillSlider();
    this.updatePriceDisplay();
  }

  setMinAndMaxValues() {
    const numberInputs = this.querySelectorAll('.facets__price-wrapper .field__input');
    const minInput = numberInputs[0];
    const maxInput = numberInputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  updatePriceDisplay() {
    const valuesEl = this.querySelector('.facets__price-values');
    const numberWrapper = this.querySelector('.facets__price-wrapper');
    if (!valuesEl || !numberWrapper || typeof formatMoney !== 'function') return;

    const inputs = numberWrapper.querySelectorAll('.field__input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;

    const minCents = (parseInt(minInput.value, 10) || 0) * 100;
    const maxCents = (parseInt(maxInput.value, 10) || parseInt(maxInput.getAttribute('max'), 10) || 0) * 100;
    const minEl = valuesEl.querySelector('.facets__price-values-min');
    const maxEl = valuesEl.querySelector('.facets__price-values-max');

    if (minEl) minEl.textContent = formatMoney(minCents);
    if (maxEl) maxEl.textContent = formatMoney(maxCents);
  }

  fillSlider() {
    const inputWrapper = this.querySelector('.facets__range');
    if (!inputWrapper) return;

    const inputsRange = inputWrapper.querySelectorAll('.field__range');
    const inputRangeFrom = inputsRange[0];
    const inputRangeTo = inputsRange[1];
    if (!inputRangeFrom || !inputRangeTo) return;

    const range = inputRangeTo.max - inputRangeTo.min;
    if (!range) return;

    const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
    const toCurrent = inputRangeTo.value - inputRangeTo.min;
    const minRange = (fromCurrent / range) * 100;
    const maxRange = (toCurrent / range) * 100;

    inputWrapper.setAttribute(
      'style',
      `--range-min: ${minRange}%; --range-max: ${maxRange}%`
    );
  }

  syncSliderState() {
    this.fillSlider();
    this.updatePriceDisplay();
  }

  controlSlider() {
    const inputWrapper = this.querySelector('.facets__range');
    const numberWrapper = this.querySelector('.facets__price-wrapper');
    if (!inputWrapper || !numberWrapper) return;

    const inputsRange = inputWrapper.querySelectorAll('.field__range');
    const inputRangeFrom = inputsRange[0];
    const inputRangeTo = inputsRange[1];
    const inputNumberFrom = numberWrapper.querySelectorAll('.field__input')[0];
    const inputNumberTo = numberWrapper.querySelectorAll('.field__input')[1];

    inputRangeFrom.oninput = () => {
      const from = parseInt(inputRangeFrom.value, 10);
      const to = parseInt(inputRangeTo.value, 10);
      if (from > to) {
        inputRangeFrom.value = to;
        inputNumberFrom.value = to;
      } else {
        inputNumberFrom.value = from;
      }

      this.syncSliderState();
    };

    if (Number(inputRangeTo.value) <= 0) {
      inputRangeTo.style.zIndex = 2;
    } else {
      inputRangeTo.style.zIndex = 0;
    }

    inputRangeTo.oninput = () => {
      const from = parseInt(inputRangeFrom.value, 10);
      const to = parseInt(inputRangeTo.value, 10);
      if (from <= to) {
        inputRangeTo.value = to;
        inputNumberTo.value = to;
      } else {
        inputNumberTo.value = from;
        inputRangeTo.value = from;
      }

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      this.syncSliderState();
    };
  }

  controlInput() {
    const inputWrapper = this.querySelector('.facets__range');
    const numberWrapper = this.querySelector('.facets__price-wrapper');
    if (!inputWrapper || !numberWrapper) return;

    const inputsNumber = numberWrapper.querySelectorAll('.field__input');
    const inputNumberFrom = inputsNumber[0];
    const inputNumberTo = inputsNumber[1];
    const inputRangeFrom = inputWrapper.querySelectorAll('.field__range')[0];
    const inputRangeTo = inputWrapper.querySelectorAll('.field__range')[1];

    inputNumberFrom.oninput = () => {
      const from = parseInt(inputNumberFrom.value, 10);
      const to = parseInt(inputNumberTo.value, 10);
      if (from > to) {
        inputRangeFrom.value = to;
        inputNumberFrom.value = to;
      } else {
        inputRangeFrom.value = from;
      }

      this.syncSliderState();
    };

    inputNumberTo.oninput = () => {
      const from = parseInt(inputNumberFrom.value, 10);
      const to = parseInt(inputNumberTo.value, 10);
      if (from <= to) {
        inputRangeTo.value = to;
        inputNumberTo.value = to;
      } else {
        inputNumberTo.value = from;
      }

      this.syncSliderState();
    };
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
